import * as React from 'react';

function SvgIconContactEmail(props) {
  return (
    <svg width={17} height={13} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16.84 1.66a.56.56 0 00-.13-.29A2.69 2.69 0 0014.34 0H2.67C1.63 0 .74.56.29 1.37a.56.56 0 00-.13.3c-.1.26-.16.55-.16.85v7.96A2.6 2.6 0 002.67 13h11.67A2.6 2.6 0 0017 10.48V2.52c0-.3-.06-.59-.16-.86zM2.72 1.17h11.67c.47 0 .88.21 1.15.53l-4.96 5.1a2.8 2.8 0 01-4.05 0l-.18-.19a.58.58 0 00-.16-.15L1.58 1.7c.26-.32.68-.53 1.14-.53zm11.6 10.76H2.68c-.8 0-1.45-.61-1.45-1.38V3.1l3.7 3.82-2.31 2.2a.56.56 0 000 .81c.11.11.27.17.43.17.16 0 .31-.06.42-.17l2.29-2.17a4.01 4.01 0 005.63-.16l2.46 2.33a.62.62 0 00.85 0 .56.56 0 000-.81l-2.49-2.37 3.54-3.65v7.46c0 .77-.65 1.38-1.45 1.38z" />
    </svg>
  );
}

export default SvgIconContactEmail;
